<script lang="ts">
  import { onMount } from "svelte";
  import { cookieConsent } from "../lib/cookieConsent";
  import RadioGroup from "./RadioGroup.svelte";

  let { privacyPolicyUrl }: { privacyPolicyUrl: string } = $props();
  let userChoice = $state($cookieConsent || undefined);
  let container = $state<HTMLDivElement>();

  const onsubmit = () => $cookieConsent = (userChoice || null)

  onMount(() => {
    const form = container?.closest("form");
    form?.addEventListener("submit", onsubmit);
    return () => form?.removeEventListener("submit", onsubmit);
  });
</script>

<div bind:this={container} class="ui-rhythm">
  <h2 class="ui-section-title">Allow app analytics?</h2>
  <p>
    We use cookies for core functions like secure login, remembering your choices, and fraud prevention.
    <b>This website uses no marketing cookies.</b>
  </p>
  <p>
    With your permission, we use analytics software that helps us understand
    how our clients use the portal website—without capturing any personal information.
    For details, please read our <a
      href={privacyPolicyUrl}
      class="text-blue-600 hover:underline hover:text-blue-600 focus:text-blue-600"
      target="_blank">Privacy Policy</a
    >.
  </p>
  <RadioGroup name="cookie_consent" bind:group={userChoice} options={[
    ["Necessary Cookie Use Only", "necessary"],
    ["Allow App Analytics", "all"],
  ]} />
</div>
